// services/shiftSettings.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IShiftSettings } from "../shiftSettingsModal";
import moment from "moment";

export const getAllShiftSettings = createAsyncThunk(
  "ShiftSettings/FindAllShiftSettings",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/FindAllShiftSettings`,
        {
          ShiftName: "",
        },
      );
      return response.data?.Data && response.data?.Data.length > 0
        ? (response.data?.Data as any[]).map((item) => ({
            ...item,
            StartTime: item.StartTime
              ? moment(item.StartTime, "hh:mm").format("hh:mm A")
              : "",
            EndTime: item.EndTime
              ? moment(item.EndTime, "hh:mm").format("hh:mm A")
              : "",
          }))
        : [];
    } catch (error: any) {
      console.error("Error Fetching Shift Settings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createShiftSetting = createAsyncThunk(
  "ShiftSettings/InsertShiftSettings",
  async (shiftData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/InsertShiftSettings`,
        shiftData,
      );
      SuccessToast(
        response.data?.Details || "Shift setting created successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Shift Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateShiftSetting = createAsyncThunk(
  "ShiftSettings/UpdateShiftSettings",
  async (shiftData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/UpdateShiftSettings`,
        shiftData,
      );
      SuccessToast(
        response.data?.Details || "Shift setting updated successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Shift Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteShiftSetting = createAsyncThunk(
  "ShiftSettings/DeleteShiftSettings",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/DeleteShiftSettings`,
        { ID },
      );
      SuccessToast(
        response.data?.Details || "Shift setting deleted successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Shift Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getShiftSettingByID = createAsyncThunk(
  "ShiftSettings/FindByIDShiftSettings",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/FindByIDShiftSettings`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ShiftName: result.ShiftName,
        StartTime: result.StartTime
          ? moment(result.StartTime, "hh:mm A").toDate()
          : "",
        EndTime: result.EndTime
          ? moment(result.EndTime, "hh:mm A").toDate()
          : "",
        SlotDuration: result.SlotDuration,
        DoctorID: result.DoctorID,
        // BranchID: result.BranchID,
        ApplicableDays: result.ApplicableDays
          ? result.ApplicableDays?.split(",")?.map((day: string) => day)
          : "",
        IsActive: result.IsActive === true ? 1 : 2,
      } as IShiftSettings;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Shift Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveShiftSettings = createAsyncThunk(
  "ShiftSettings/FindAllActiveShiftSettings",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ShiftSettings/FindAllActiveShiftSettings`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Shift Settings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveShiftSetting = createAsyncThunk(
  "ShiftSettings/ActiveInActiveShiftSettings",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShiftSettings/ActiveInActiveShiftSettings`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating shift setting status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
